import * as normalize from 'utils/normalize';

import getOrderAuthorization from 'utils/print/getOrderAuthorization';
import getPatientName from 'utils/print/getPatientName';
import getPatientFullDob from 'utils/print/getPatientFullDob';
import getPatientRecordNumber from 'utils/print/getPatientRecordNumber';
import getPrescriberName from 'utils/print/getPrescriberName';
import getPrescriberFullPhone from 'utils/print/getPrescriberFullPhone';
import getPrescriberNPI from 'utils/print/getPrescriberNPI';
import getPrescriberFullFax from 'utils/print/getPrescriberFullFax';
import getPrescriberAddress from 'utils/print/getPrescriberAddress';
import getPrescriberCityState from 'utils/print/getPrescriberCityState';
import getPrescriberZip from 'utils/print/getPrescriberZip';
import getSupplierName from 'utils/print/getSupplierName';
import getSupplierFullPhone from 'utils/print/getSupplierFullPhone';
import getSupplierNSCorNPI from 'utils/print/getSupplierNSCorNPI';
import getSupplierFullFax from 'utils/print/getSupplierFullFax';
import getFacilityStreet from 'utils/print/getFacilityStreet';
import getFacilityZip from 'utils/print/getFacilityZip';
import getFacilityCityState from 'utils/print/getFacilityCityState';
import getInquiringProviderUserName from 'utils/print/getInquiringProviderUserName';
import getDiagnosisCode from 'utils/print/getDiagnosisCode';
import getOrderLineHCPCSCode from 'utils/print/getOrderLineHCPCSCode';
import getOrderLineUnits from 'utils/print/getOrderLineUnits';
import getOrderLineDescription from 'utils/print/getOrderLineDescription';
import getOrderLineType from 'utils/print/getOrderLineType';
import getOrderLineDosFromTo from 'utils/print/getOrderLineDosFromTo';

const PriorAuthorizationTemplateAffinityAuthorizationRequest = {
  ID: 22,
  Name: 'Affinity Authorization Request',
  Type: 'Prior Authorization Template',
  Format: 'letter',
  Orientation: 'p',
  OrderLineMax: 7,
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/Prior-Authorization-Template-Affinity-Authorization-Request/1.js',
      fields: [
        {
          name: 'Authorization Number',
          type: 'text',
          getValue: props => getOrderAuthorization(props),
          x: 167,
          y: 34,
          width: 29,
        },
        {
          name: 'Type of Request',
          type: 'radio',
          outline: true,
          options: [
            {
              x: 58,
              y: 46.5,
              width: 16,
              height: 4,
              value: 'Standard',
            },
            {
              x: 76,
              y: 46.5,
              width: 13,
              height: 4,
              value: 'Urgent',
            },
          ],
        },
        {
          name: 'If Urgent, please indicate why',
          type: 'text',
          x: 57,
          y: 50,
          width: 77,
        },
        {
          name: 'Authorization Type',
          type: 'radio',
          outline: true,
          options: [
            {
              x: 60,
              y: 59.5,
              width: 22,
              height: 4,
              value: 'Initial Request',
            },
            {
              x: 82,
              y: 59.5,
              width: 17,
              height: 4,
              value: 'Concurrent',
            },
            {
              x: 100,
              y: 59.5,
              width: 21,
              height: 4,
              value: 'Retrospective',
            },
          ],
        },
        {
          name: 'Date',
          type: 'text',
          x: 149,
          y: 58,
          width: 45,
          normalize: normalize.date,
        },
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 29,
          y: 75,
          width: 66,
        },
        {
          name: 'Patient DOB',
          type: 'text',
          getValue: getPatientFullDob,
          x: 108,
          y: 75,
          width: 26,
          normalize: normalize.date,
        },
        {
          name: 'Patient ID',
          type: 'text',
          getValue: getPatientRecordNumber,
          x: 146,
          y: 75,
          width: 49,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'ORDERING PHYSICIAN Full Name',
          type: 'text',
          getValue: getPrescriberName,
          x: 29,
          y: 92,
          width: 82,
        },
        {
          name: 'ORDERING PHYSICIAN Phone',
          type: 'text',
          getValue: getPrescriberFullPhone,
          x: 138,
          y: 92,
          width: 51,
          normalize: normalize.phone,
        },
        {
          name: 'ORDERING PHYSICIAN NPI',
          type: 'text',
          getValue: getPrescriberNPI,
          x: 21,
          y: 99,
          width: 90,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'ORDERING PHYSICIAN Fax',
          type: 'text',
          getValue: getPrescriberFullFax,
          x: 134,
          y: 99,
          width: 51,
          normalize: normalize.phone,
        },
        {
          name: 'ORDERING PHYSICIAN Address',
          type: 'text',
          getValue: getPrescriberAddress,
          x: 26,
          y: 105.5,
          width: 166,
        },
        {
          name: 'ORDERING PHYSICIAN City State',
          type: 'text',
          getValue: getPrescriberCityState,
          x: 29,
          y: 112,
          width: 82,
        },
        {
          name: 'ORDERING PHYSICIAN Zip',
          type: 'text',
          getValue: getPrescriberZip,
          x: 134,
          y: 112,
          width: 52,
          normalize: normalize.zip,
        },
        {
          name: 'SERVICING PROVIDER Name',
          type: 'text',
          getValue: getSupplierName,
          x: 29,
          y: 129,
          width: 83,
        },
        {
          name: 'SERVICING PROVIDER Phone',
          type: 'text',
          getValue: getSupplierFullPhone,
          x: 138,
          y: 129,
          width: 52,
          normalize: normalize.phone,
        },
        {
          name: 'SERVICING PROVIDER NPI',
          type: 'text',
          getValue: getSupplierNSCorNPI,
          x: 21,
          y: 135,
          width: 90,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'SERVICING PROVIDER Fax',
          type: 'text',
          getValue: getSupplierFullFax,
          x: 134,
          y: 135,
          width: 52,
          normalize: normalize.phone,
        },
        {
          name: 'SERVICING PROVIDER Address',
          type: 'text',
          getValue: getFacilityStreet,
          x: 26,
          y: 141.5,
          width: 166,
        },
        {
          name: 'SERVICING PROVIDER City State',
          type: 'text',
          getValue: getFacilityCityState,
          x: 29,
          y: 148,
          width: 81,
          normalize: normalize.zip,
        },
        {
          name: 'SERVICING PROVIDER Zip',
          type: 'text',
          getValue: getFacilityZip,
          x: 133,
          y: 148,
          width: 52,
          normalize: normalize.zip,
        },
        {
          name: 'SERVICING PROVIDER Contact Name',
          type: 'text',
          getValue: getInquiringProviderUserName,
          x: 35,
          y: 154.5,
          width: 77,
        },
        {
          name: 'SERVICING PROVIDER Phone 2',
          type: 'text',
          getValue: getSupplierFullPhone,
          x: 138,
          y: 154.5,
          width: 52,
          normalize: normalize.phone,
        },
        {
          name: 'Supporting Documentation Included Prescription',
          type: 'checkbox',
          outline: true,
          x: 100,
          y: 164,
          width: 22,
          height: 4,
        },
        {
          name: 'Supporting Documentation Included LMN',
          type: 'checkbox',
          outline: true,
          x: 127,
          y: 164,
          width: 10,
          height: 4,
        },
        {
          name: 'Supporting Documentation Included Office visit notes',
          type: 'checkbox',
          outline: true,
          x: 143,
          y: 164,
          width: 26,
          height: 4,
        },
        {
          name: 'Diagnoses',
          type: 'text',
          getValue: getDiagnosisCode,
          x: 29,
          y: 169.5,
          width: 75,
        },
        ...[0, 1, 2, 3, 4, 5, 6].reduce((accumulator, currentValue) => {
          const y = 196 + (currentValue * 6.6);
          return [
            ...accumulator,
            {
              name: `HCPC Code ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineHCPCSCode({ ...props, index: currentValue }),
              x: 12,
              y,
              width: 37,
            },
            {
              name: `Service Description ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineDescription({ ...props, index: currentValue }),
              x: 51,
              y,
              width: 56,
            },
            {
              name: `Qty ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineUnits({ ...props, index: currentValue }),
              x: 109,
              y,
              width: 18,
              normalize: normalize.number,
            },
            {
              name: `Type ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineType({ ...props, index: currentValue }),
              x: 130,
              y,
              width: 29,
            },
            {
              name: `DOS From To ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineDosFromTo({ ...props, index: currentValue }),
              x: 163,
              y,
              width: 38,
            },
          ];
        }, []),
        {
          name: 'Additional Details (if necessary)',
          type: 'text',
          x: 10,
          y: 245,
          width: 192,
          height: 15,
          multiline: true,
        },
      ],
    },
  ],
};

export default PriorAuthorizationTemplateAffinityAuthorizationRequest;



// WEBPACK FOOTER //
// ./src/config/documents/Prior-Authorization-Template-Affinity-Authorization-Request.js